export default "__VITE_ASSET__p6PLMcos__"